import type { AxiosResponse } from "axios";
import type {
  FormSubmissionActionResponse,
  FormSubmissionListResponse,
} from "../../../../shared/apiTypes";
import api from "../api";
import {
  GET_HELD_SUBMISSIONS,
  HELD_SUBMISSIONS_LOADING,
  REMOVE_HELD_SUBMISSION,
} from "./heldSubmissionsTypes";
import { GET_ERRORS } from "../errorServices/errorTypes";
import { setAppMessage } from "../appMessageServices/appMessageActions";

// The server's own reason (`{ errors: [{ msg }] }` — 409 "Submission is not
// held", 503 "Sender email not configured…") goes to the error hub as-is, the
// same guard as pendingChangesActions (SCRUM-1312).
const surface = (dispatch, err) =>
  dispatch({
    type: GET_ERRORS,
    payload: err?.response?.data ?? { message: err?.message },
  });

export const fetchHeldSubmissions = () => async (dispatch) => {
  dispatch({ type: HELD_SUBMISSIONS_LOADING });
  try {
    const res: AxiosResponse<FormSubmissionListResponse> = await api.get("/api/form-submissions?status=held");
    dispatch({ type: GET_HELD_SUBMISSIONS, payload: res.data });
  } catch (err) {
    dispatch({ type: GET_HELD_SUBMISSIONS, payload: [] });
    surface(dispatch, err);
  }
};

/**
 * One reviewer action; the row leaves the list only when the server answered
 * 2xx. Rejects on failure so a ConfirmDelete `onConfirm` sees the outcome.
 */
const act = (action: "release" | "discard", id: string) => async (dispatch) => {
  try {
    const res: AxiosResponse<FormSubmissionActionResponse> = await api.post(`/api/form-submissions/${id}/${action}`);
    dispatch({ type: REMOVE_HELD_SUBMISSION, payload: id });
    dispatch(
      setAppMessage(
        "success",
        action === "release"
          ? res.data?.status === "dispatch_failed"
            ? "Submission released, but the mail could not be sent"
            : "Submission released and sent"
          : "Submission discarded",
      ),
    );
  } catch (err) {
    surface(dispatch, err);
    throw err;
  }
};

export const releaseSubmission = (id: string) => act("release", id);
export const discardSubmission = (id: string) => act("discard", id);
